export default function Share({ width }) {
    return (
        <>
            <lottie-player src="https://assets1.lottiefiles.com/packages/lf20_4xt9ugq9.json" background="transparent" speed="1" style={{ width: width }} loop autoplay></lottie-player>
        </>
    )
}